// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jBcB","name":"styles_name__2Dk14","phone":"styles_phone__2xFH3"};